import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { API } from 'src/environments/environment';
import { UtilService } from 'src/app/service/util.service';
import { AjaxService } from 'src/app/service/ajax.service';
import { DataTablesModule } from 'angular-datatables';

interface Usuario {
  id: number;
  nome: string;
  login: string;
  ativo: boolean;
  idEncrypted: string;
  pessoaNome: string;
  pessoaCpf: string;
  pessoaEmail: string;
  pessoaDataNascimento: Date;
  pessoaTelefone: string;
}

@Component({
  selector: 'app-cadastro-usuario-gestao',
  templateUrl: './cadastro-usuario-gestao.component.html',
  styleUrls: ['./cadastro-usuario-gestao.component.scss']
})
export class CadastroUsuarioGestaoComponent implements OnInit {
  usuarioForm: FormGroup;
  isEditing = false;
  isInactive = false;
  usuarios: Usuario[] = [];
  dtOptions: DataTables.Settings = {};
  usuarioSelecionado: Usuario | null = null;

  constructor(
    private fb: FormBuilder,
    private ajax: AjaxService,
    private util: UtilService
  ) {
    this.usuarioForm = this.fb.group({
      id: [''],
      nome: ['', [Validators.required]],
      login: ['', [Validators.required, Validators.maxLength(30)]],
      pessoaNome: [''],
      pessoaCpf: [''],
      pessoaEmail: ['', Validators.email],
      pessoaDataNascimento: [''],
      pessoaTelefone: ['']
    });
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.13.7/i18n/pt-BR.json'
      },
      responsive: true,
      order: [[0, 'desc']]
    };
    this.carregarUsuarios();
  }

  carregarUsuarios() {
    this.util.showLoading();
    this.ajax.get(`${API}Usuario/Usuario`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.usuarios = response.data.map((usuario: any) => ({
              id: usuario.id,
              nome: usuario.nome,
              login: usuario.login,
              ativo: usuario.ativo,
              idEncrypted: usuario.idEncrypted,
              pessoaNome: usuario.pessoaNome,
              pessoaCpf: usuario.pessoaCpf,
              pessoaEmail: usuario.pessoaEmail,
              pessoaDataNascimento: usuario.pessoaDataNascimento ? new Date(usuario.pessoaDataNascimento) : null,
              pessoaTelefone: usuario.pessoaTelefone
            }));
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", "Erro ao carregar usuários. Por favor, tente novamente.");
          console.error('Erro ao carregar usuários:', error);
        }
      });
  }

  onSubmit() {
    if (this.usuarioForm.valid) {
      this.util.showLoading();
      
      const dados = {
        id: this.usuarioForm.get('id').value,
        nome: this.usuarioForm.get('nome').value,
        login: this.usuarioForm.get('login').value,
        pessoaNome: this.usuarioForm.get('pessoaNome').value,
        pessoaCpf: this.usuarioForm.get('pessoaCpf').value,
        pessoaEmail: this.usuarioForm.get('pessoaEmail').value,
        pessoaDataNascimento: this.usuarioForm.get('pessoaDataNascimento').value,
        pessoaTelefone: this.usuarioForm.get('pessoaTelefone').value,
        IdEncCrud: this.usuarioSelecionado.idEncrypted
      };

      const url = this.usuarioSelecionado 
        ? `${API}Usuario/Usuario?IdEncCrud=${this.usuarioSelecionado.idEncrypted}`
        : `${API}Usuario/Usuario/valor-saude`;

      const request = this.usuarioSelecionado
        ? this.ajax.put(url, dados)
        : this.ajax.post(url, dados);

      request.subscribe({
        next: (response) => {
          this.util.closeLoading();
          this.util.toasterShowSuccess("Sucesso", 
            this.usuarioSelecionado 
              ? "Usuário atualizado com sucesso!" 
              : "Usuário cadastrado com sucesso!");
          this.limparFormulario();
          this.carregarUsuarios();
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", error.error.message);
          console.error('Erro ao salvar usuário:', error);
        }
      });
    } else {
      this.util.toasterShowError("Atenção", "Por favor, preencha todos os campos obrigatórios.");
    }
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
    if (this.isEditing) {
      this.usuarioForm.enable();
    } else {
      this.usuarioForm.disable();
      this.limparFormulario();
    }
  }

  editarUsuario(usuario: Usuario) {
    this.usuarioSelecionado = usuario;
    this.isEditing = true;
    this.usuarioForm.patchValue({
      id: usuario.id,
      nome: usuario.nome,
      login: usuario.login,
      pessoaNome: usuario.pessoaNome,
      pessoaCpf: usuario.pessoaCpf,
      pessoaEmail: usuario.pessoaEmail,
      pessoaDataNascimento: usuario.pessoaDataNascimento,
      pessoaTelefone: usuario.pessoaTelefone
    });
    this.usuarioForm.enable();
  }

  limparFormulario() {
    this.usuarioForm.reset();
    this.usuarioForm.disable();
    this.isEditing = false;
    this.usuarioSelecionado = null;
  }

  inativarUsuario(usuario: Usuario) {
    this.util.showLoading();
    const novoStatus = !usuario.ativo;
    
    this.ajax.put(`${API}Usuario/Usuario/${usuario.id}`, { ativo: novoStatus })
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          this.util.toasterShowSuccess("Sucesso", 
            novoStatus ? "Usuário ativado com sucesso!" : "Usuário inativado com sucesso!");
          this.carregarUsuarios();
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", error.error.message);
          console.error('Erro ao alterar status do usuário:', error);
        }
      });
  }
} 